import { productPrice } from "../../utils/productPricing";
import React, { useEffect, useState } from "react";
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { FiChevronRight, FiChevronLeft, FiChevronsRight } from 'react-icons/fi'
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import axios from "../../api/api"
import SmartImage from "../SmartImage";
import { formatCurrency, fetchExchangeRates } from "../../utils/currencyUtils";

const Products = ({ title, products }) => {
    const { userInfo } = useSelector((state) => state.auth);
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    }

    const [currencyCode, setCurrencyCode] = useState("USD");
    const [exchangeLoaded, setExchangeLoaded] = useState(false);

    useEffect(() => {
        fetchExchangeRates().then(() => setExchangeLoaded(true));
    }, []);
    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const { data } = await axios.get("/account/get-details", {
                    withCredentials: true,
                });
                if (data.currency) {
                    setCurrencyCode(data.currency);
                }
            } catch (error) {
                // Handle error silently
            }
        };

        if (userInfo && userInfo.id) {
            fetchUserDetails();
        }
    }, []);
    const ButtonGroup = ({ next, previous }) => {
        return (
            <div className='flex justify-between items-center'>
                <div className='text-lg font-bold text-white'>{title}</div>
                <div className='flex justify-center items-center gap-3 text-slate-600'>
                    <button onClick={() => previous()} className='w-[30px] h-[30px] flex justify-center items-center text-white rounded-sm bg-[#1C1C1C] font-semibold'>
                        <span><FiChevronLeft /></span>
                    </button>
                    <button onClick={() => next()} className='w-[30px] h-[30px] flex justify-center items-center text-white rounded-sm bg-[#1C1C1C] font-semibold'>
                        <span><FiChevronRight /></span>
                    </button>
                </div>
            </div>
        )
    }
    return (
        <div className='flex gap-8 flex-col-reverse'>
            <Carousel
                autoPlay={false}
                infinite={false}
                arrows={false}
                responsive={responsive}
                transitionDuration={500}
                renderButtonGroupOutside={true}
                customButtonGroup={<ButtonGroup />}

            >
                {
                    products.map((p, i) => {
                        return (
                            <div key={i} className='flex flex-col justify-start gap-2 '>
                                {
                                    p.map((pl, j) => <Link key={j} to={pl.shopName ? `/${pl.shopName}/product/details/${pl._id}` : `/product/details/${pl._id}`} className='flex justify-start rounded-md items-start bg-[#070707]  p-2 mb-2' >
                                        <SmartImage className='w-[80px] h-[80px] rounded-md nex_img_cover' src={pl.images?.[0]} alt={pl.name} width={160} iconSize={28} />
                                        <div className='px-3 flex justify-start items-start gap-1 flex-col text-white'>
                                            <h2 className='text-[13px]'>{pl.name?.slice(0, 40)}</h2>
                                            <span className='text-md font-bold'> {productPrice(pl, currencyCode)}</span>
                                            <p className='text-[13px]'>{pl.description?.slice(0, 40)}...</p>
                                        </div>

                                    </Link>)
                                }
                            </div>
                        )
                    })
                }
            </Carousel>
        </div>
    )
}

export default Products